define([
    "base/utils/iamHttpService",
    "language/resource",
    "authui/iamUtils",
    "authui/iamEnv",
    "base/js/loginverification/controllers/loginVerificationController",
    "base/utils/htmlTransformer",
    "qrcode"
],
    function (iamHttpService, i18n, iamUtils, iamEnv, verifyCtr, htmlTransformer, QRCode){
        "use strict";
        var ipIsInternational = iamUtils.ipIsInternational();
        var loginVerificationCtrl = function($scope, $sce, $filter, $interval){
            this.timeFormat = "yyyy-MM-dd HH:mm:ss";
            if(ipIsInternational)
            {
                if(window.language && window.language !=="en-us"){
                    $scope.mfaHelp = "https://support-intl.huaweicloud.com/"+ window.language + "/iam_faq/iam_01_0001.html";
                }else{
                    $scope.mfaHelp = "https://support-intl.huaweicloud.com/iam_faq/iam_01_0001.html";
                }
            }else{
                if(window.language && window.language !=="zh-cn"){
                    $scope.mfaHelp = "https://support.huaweicloud.com/"+ window.language + "/iam_faq/iam_01_0001.html";
                }else{
                    $scope.mfaHelp = "https://support.huaweicloud.com/iam_faq/iam_01_0001.html";
                }
            }

            $scope.isSupport = true;
            try{
                iamUtils.initialCloudBI("/authui/public/custom/loginVerification.html#/loginVerification",{C1:"IAM-Login-Verificcation"});
            }catch(e){
                console.dir(e)
            }

            // const cssMap = {
            //     'zh-cn': require('custom/css/zh-cn/loginVerification.css'),
            //     'en-us': require('custom/css/en-us/loginVerification.css'),
            //     'pt-br': require('custom/css/pt-br/loginVerification.css'),
            //     'es-us': require('custom/css/es-us/loginVerification.css'),
            // }

            // debugger;

            // $scope.cssFile = cssMap[window.language];

            $scope.countryCodeModel = {
                height:"32px",
                tipPosition:"top",
                countryCodeSelectId: "countryCodeSelectId",
                disable:false,
                defaultCodeValue: "",
                countryCodeList: [],
                countryCodeArray: [],
                countryCodeValue: "",
                codeSelectWidth: "140px",
                countryCodeSelect: function() {
                    $scope.countryCodeModel.defaultCodeValue = $("#"+$scope.countryCodeModel.countryCodeSelectId).widget().getValue();
                },
            }

            /* 身份验证需求相关 */
            function send2CloudBISafe(){
                try{
                    send2CloudBI.apply(null,arguments);
                    
                }catch(e){
                    console.dir(e)
                }
            }
            this.productTypeIsHWS = true;
            $scope.authModel = {
                tipPosition:"top",
                tipWidth: "250px",

                // 绑定手机相关
                defaultValue: "",
                countryCodeList: "",
                countryValue: "",
                completeMobile: "",
                haveBindPhone: false,
                bindPhoneId:"bindPhoneId",
                bindPhoneInputWidth: window.language == "zh-cn"?"215px":"215px",
                bindPhoneInputHeight: "32px",
                bindPhonePH: i18n("loginVerification.bindPhonePH"),
                bindPhoneValidator: iamUtils.validator.phoneAddIntl(),

                // 绑定邮箱相关
                haveBindEmail: false,
                bindEmailId:"bindEmailId",
                bindEmailInputWidth: "250px",
                bindEmailInputHeight: "32px",
                bindEmailPH: i18n("loginVerification.bindEmailPH"),
                bindEmailValidator: iamUtils.validator.email(),

                // 绑定虚拟MFA相关
                resetMFAHelpUrl: getResetMFAHelpUrl(),
                havaBindMFA: false,
                showBindMFA: false,
                disabledMFASubmitBtn: true,
                MFACodeInputWidth: "300px",
                MFACodeInputHeight: "32px",
                domainName: "",
                userName: "",
                secretKey: "",
                serialNumber: "",
                firstMFACodeId: "firstMFACodeId",
                firstMFACodeValue: "",
                secondMFACodeId: "secondMFACodeId",
                secondMFACodeValue: "",

                // 7天内无需验证虚拟MFA
                rememberMFA: false,
                rememberMFADisabled: false,
                showrememberMFACheckbox: false,
                rememberMFALabel: i18n('loginVerification.rememberMFALabel'),
                goBindMFA: function() {
                    $scope.authModel.showBindMFA = true;
                    // 获取绑定MFA信息和二维码
                    iamHttpService.get({
                        url:"/authui/getMfaBindingInfo",
                        mask: true
                    }).then(function(data){
                        var data = typeof data === "object" ? data : $.parseJSON(data);
                        if (data.retinfo == "success") {
                            $scope.authModel.MFAErrorTxt = "";
                            $scope.authModel.domainName = data.domainName;
                            $scope.authModel.userName = data.username;
                            $scope.authModel.secretKey = data.secretKey;
                            $scope.authModel.serialNumber = data.serialNumber;
                            var content = "otpauth://totp/huawei:" + data.username + "?secret=" + data.secretKey;
                            var MFAQRCodeDiv = document.querySelector('#MFAQRCodeDiv');
                            MFAQRCodeDiv.innerHTML = "";
                            QRCode.toCanvas(
                                MFAQRCodeDiv,
                                content,
                                {
                                    margin: 0,
                                    width: 120,
                                }
                            );
                        } else {
                            $scope.authModel.MFAErrorTxt = i18n("systemException");
                        }
                        $scope.$apply();
                    },function(){
                        $scope.authModel.MFAErrorTxt = i18n("systemException");
                        $scope.$apply();
                    });
                },
                MFACodeChange: function(event, value) {
                    if ($scope.authModel.firstMFACodeValue.length > 0 && $scope.authModel.secondMFACodeValue.length > 0) {
                        $scope.authModel.disabledMFASubmitBtn = false;
                        // 擦除错误提示
                        $scope.authModel.MFAErrorTxt = "";
                    } else {
                        $scope.authModel.disabledMFASubmitBtn = true;
                    }
                },
                submitBindMFA: function() {
                    bindVirtualMFA($scope, iamHttpService);
                },
                cancelBindMFA: function() {
                    $scope.authModel.showBindMFA = false;
                },

                // 验证码输入框
                verifyCodeId:"verifyCodeId",
                verifyCodeInputWidth: "145px",
                verifyCodeInputHeight: "32px",
                verifyCodePH: i18n("loginVerification.verifyCodePH"),
                verifyCodeEmailPH: i18n("loginVerification.verifyCodeEmailPH"),
                verifyCodeBtnTxt: i18n("loginVerification.verifyCodeBtnTxt"),
                verifyCodeBlur: function() {
                    
                },
                verifyCodeChange: function(event, value) {
                    $scope.model.actionError = "";
                    if (value.length > 0) {
                        $scope.authModel.disabledSubmitBtn = false;
                    } else {
                        $scope.authModel.disabledSubmitBtn = true;
                    }
                },
                smsCodeValidator: iamUtils.validator.smsMsgCode(),
                emailCodeValidator: iamUtils.validator.msgCodeForHC(),
                mfaValidator: iamUtils.validator.mfaCode(),
                sendCodeSuccess: false,
                sendCodeTxt: i18n("loginVerification.sendCodeTxt"),
                // 未绑定手机和邮箱时获取验证码
                getVerifyCode: function() {
                    if ($scope.model.verificationType === 'sms') {
                        $scope.authModel.haveBindPhone ? getBoundVerifyCode($scope, iamHttpService) : getUnbindVerifyCode($scope, iamHttpService);
                    } else if ($scope.model.verificationType === 'email') {
                        $scope.authModel.haveBindEmail ? getBoundVerifyCode($scope, iamHttpService) : getUnbindVerifyCode($scope, iamHttpService);
                    } else {
                        $scope.model.actionError = i18n("systemException");
                    }
                },
                // 继续登录
                disabledSubmitBtn: true,
                submitBtn: function() {
                    submitLogin($scope, iamUtils, iamEnv);
                },
                
                isSendSmsCodeFailed :false,
                keypress: function (event) {
                    if(event.keyCode===13){
                        $scope.authModel.submitBtn();
                    }
                },
                bindMFAKeypress: function (event) {
                    if(event.keyCode===13){
                        $scope.authModel.submitBindMFA();
                    }
                }
            };
            
            getCountryCode();

            $scope.authModel.rememberMFADisabled = !isRememberMFASupported();

            // 未绑定手机或邮箱时获取验证码
            function getUnbindVerifyCode($scope, iamHttpService) {
                var countryCode = iamUtils.getCodeValue($scope.countryCodeModel.countryCodeList, $scope.countryCodeModel.defaultCodeValue);
                //  绑定手机或邮箱前发送验证码
                var params = {};
                var bindPhoneValue = $("#"+$scope.authModel.bindPhoneId+">input").val();
                switch($scope.model.verificationType) {
                    case "sms": params = { mobile: countryCode + "-" + bindPhoneValue }; break;
                    case "email": params = { email: $scope.authModel.bindEmailValue }; break;
                    default: params = {}; break;
                }
                var config = {
                    url : "/authui/sendBindCode",
                    mask: true,
                    params: params
                };
                var promise = iamHttpService.post(config);
                promise.then(function(data){
                    // 擦除错误提示
                    $scope.model.actionError = "";

                    var data = typeof data === "object" ? data : $.parseJSON(data);
                    if(data.retinfo === 'success'){
                        // 验证码发送成功
                        $scope.authModel.sendCodeSuccess = true;
                        retrieveCountdown();
                    }else {
                        // 验证码发送失败
                        $scope.authModel.sendCodeSuccess = false;
                        if (data.retcode == 400) {
                            // 您输入的邮箱或手机号不可用。
                            $scope.model.actionError = i18n("loginVerification.validEmailOrPhone");
                        } else if (data.retcode == 401) {
                            // 操作过于频繁
                            $scope.model.actionError = i18n("operationTooFrequent");;
                        } else if (data.retcode == 402) {
                            // 获取验证码功能已被锁定
                            $scope.model.actionError = i18n("verifyCode.locked");;
                        } else if (data.retcode == 503) {
                            // 服务器发送手机或email失败。如其他号码则未知异常
                            $scope.model.actionError = i18n("loginVerification.sendCodeFailed");
                        } else {
                            $scope.model.actionError = i18n("systemException");
                        }
                    }
                    $scope.$apply();
                } , function(){
                    // 接口错误
                    $scope.authModel.disabledSubmitBtn = true;
                    $scope.model.actionError = i18n("systemException");
                    $scope.$apply();
                });
            }

            // 已绑定手机或邮箱时获取验证码
            function getBoundVerifyCode($scope, iamHttpService) {
                if($scope.model.verificationType) {
                    send2CloudBISafe("button", "click" , "login_verification_" + $scope.model.verificationType , '');
                }

                iamHttpService.post({
                    url: "/authui/sendLoginSms",
                    params: {}
                }).then(function(data){
                    // 擦除错误提示
                    $scope.model.actionError = "";

                    var data = typeof data === "object" ? data : $.parseJSON(data);
                    if (data.result === "success") {
                        var remainderCount = data.remainderCount;
                        if(remainderCount >= 0) {
                            var content = remainderCount == 0? i18n("verifyCode.cantAcquire"):
                                iamUtils.i18nFormat(i18n("verifyCode.remainderCount"), remainderCount);
                            $scope.model.actionError = content;
                            if(remainderCount > 0){
                                retrieveCountdown();
                            }else{
                                $scope.$apply();
                            } 
                        } else {
                            // 验证码发送成功
                            $scope.authModel.sendCodeSuccess = true;
                            retrieveCountdown();
                        }
                        return;
                    } else if (data.result === "faster") {
                        $scope.model.actionError = i18n("verifyCode.intervalError");
                    } else if(data.result === "locked") {
                        var lockedMsg = i18n("verifyCode.locked");
                        if (data.lockDuration && data.lockDuration !== -1) {
                            lockedMsg = iamUtils.i18nFormat(i18n("verifyCode.locked.custom"), data.lockDuration);
                        }
                        $scope.model.actionError = lockedMsg;
                    } else if(data.result === "error") {
                        $scope.model.actionError = i18n("verifyCode.sendFailed");
                    }
                }, function(data){
                    if (data.status == 403) {
                        var btnBack2Login = [{
                            key: "btnwed12",
                            label: i18n("btnTxtOK"),
                            accessKey: '3',
                            focused: true,
                            handler: function (event) {
                                iamUtils.redirect2Login();
                            }
                        }];
                        iamUtils.MESSAGE.ERROR(i18n("sessionExpired"), "", "popupMsg", btnBack2Login, iamUtils.redirect2Login);
                    } else {
                        $scope.model.actionError = i18n("systemException");
                    }
                });
            }

            //为用户绑定虚拟MFA
            function bindVirtualMFA($scope, iamHttpService){
                if ($scope.authModel.disabledMFASubmitBtn) {
                    return;
                }
                $scope.authModel.disabledMFASubmitBtn = true;
                var config = {
                    url : "/authui/bindMfa",
                    mask: true,
                    params:{
                        serialNumber : $scope.authModel.serialNumber,
                        firstRegCode: $("#"+$scope.authModel.firstMFACodeId+">input").val(),
                        secondRegCode: $("#"+$scope.authModel.secondMFACodeId+">input").val(),
                    }
                };
                var promise = iamHttpService.post(config);
                promise.then(function(data){
                    var data = typeof data === "object" ? data : $.parseJSON(data);
                    if(data.retinfo === 'success'){
                        if(data.retcode == 0){
                            // 绑定成功
                            $scope.authModel.showBindMFA = false;
                            $scope.authModel.havaBindMFA = true;
                            iamUtils.MESSAGE.PROMPT(i18n("loginVerification.bindMFASucceed"), "", "popupMsg");
                        }
                        else if(data.retcode == -1){
                            // MFA验证码错误
                            $scope.authModel.MFAErrorTxt = i18n("loginVerification.mfaCodeError");
                        }else{
                            // 系统繁忙
                            $scope.authModel.MFAErrorTxt = i18n("systemException");
                        }
                        $scope.$apply();
                    }else{
                        $scope.authModel.disabledMFASubmitBtn = true;
                        $scope.authModel.MFAErrorTxt = i18n("systemException");
                        $scope.$apply();
                    }
                } , function(){
                    // 接口错误
                    $scope.authModel.disabledMFASubmitBtn = true;
                    $scope.authModel.MFAErrorTxt = i18n("systemException");
                    $scope.$apply();
                });
            }

            // 继续登录
            function submitLogin($scope, iamUtils, iamEnv){
                send2CloudBISafe("button", "click" , "login_verification_" + $scope.model.verificationType + "_nextStep" , '');
                if(!iamUtils.unifyValid.FormValid($("#verifyCodeId"))) {
                    iamUtils.unifyValid.focusFirst($("#verifyCodeId"));
                    return;
                }

                if($scope.authModel.disabledSubmitBtn) {
                    return;
                } else {
                    $scope.authModel.disabledSubmitBtn = !$scope.authModel.disabledSubmitBtn;
                }

                if (iamEnv.isPublishEnv()) {
                    var temp = document.createElement("form");
                    if(window.location.search === ""){
                        temp.action = "/authui/validateUser";
                    }
                    else {
                        temp.action = "/authui/validateUser?" + window.location.search.substring(1,window.location.search.length);
                    }
                    temp.method = "post";
                    temp.style.display = "none";
                    if ($scope.model.verificationType!== "" && $scope.model.verificationType!=="none") {
                        
                        var opt = document.createElement("textarea");
                        opt.name = "smsCode";
                        // 修复验证位数获取错误的bug
                        // opt.value = $scope.authModel.verifyCodeValue;
                        opt.value = $("#"+$scope.authModel.verifyCodeId+">input").val();
                        temp.appendChild(opt);
                    }
                    // 如果是手机验证
                    if ($scope.model.verificationType === "sms") {
                        var mobile = document.createElement("textarea");
                        mobile.name = "mobile";
                        var countryCode = iamUtils.getCodeValue($scope.countryCodeModel.countryCodeList, $scope.countryCodeModel.defaultCodeValue);
                        var bindPhoneValue = $("#"+$scope.authModel.bindPhoneId+">input").val();
                        mobile.value = countryCode + "-" + bindPhoneValue;
                        temp.appendChild(mobile);
                    }
                    // 如果是邮箱验证
                    if ($scope.model.verificationType === "email") {
                        var email = document.createElement("textarea");
                        email.name = "email";
                        email.value = $scope.authModel.bindEmailValue;
                        temp.appendChild(email);
                    }

                    if ($scope.model.verificationType === 'vmfa') {
                    // 如果是vmfa验证
                        var rememberMFAOpt = document.createElement("textarea");
                        rememberMFAOpt.name = "rememberMFA";
                        rememberMFAOpt.value = $scope.authModel.rememberMFA;
                        temp.appendChild(rememberMFAOpt);
                    }
                    // step
                    var step = document.createElement("textarea");
                    step.name = "step";
                    step.value = "afterAntiPhishing";
                    temp.appendChild(step);
                    // IAMCSRF
                    var IAMCSRFClient = document.createElement("textarea");
                    IAMCSRFClient.name = "IAMCSRF";
                    IAMCSRFClient.value = $("#IAMCSRFClient").text();
                    temp.appendChild(IAMCSRFClient);
                    
                    //isSupport 为true 为新接口
                    if($scope.isSupport){
                        var isSupport = document.createElement("textarea");
                        isSupport.name = "isSupport";
                        isSupport.value = true;
                        temp.appendChild(isSupport);
                    }

                    // 统一ID兼容
                    if(iamUtils.getUrlParams()['isFromID']){
                        var opt = document.createElement("textarea");
                        opt.name = "isFromID";
                        opt.value = iamUtils.getUrlParams()['isFromID'];
                        temp.appendChild(opt);
                    }

                    document.body.appendChild(temp);
                    temp.submit();
                } else {
                    iamHttpService.post({
                        url: "/authui/validateUser",
                        params: {}
                    }).then(function(data){
                        if (data.loginResult === "success")
                        {
                            window.location.href = data.redirectUrl;
                            return;
                        }
                    }, function(data){
                        
                    });
                }
            }

            // 获取国家码 暂时注释
            function getCountryCode() {
                iamHttpService.get({
                    url:"/authui/getCountryCode",
                    async: false,
                    params:{}
                }).then(function (data) {
                    var data = typeof data === "object" ? data : $.parseJSON(data);
                    var codeList = data["codeArray"];
                    var defaultCode = data["defaultCode"];
                    var codeArray = [];
                    if (codeList.length) {
                        codeList = codeList.sort(iamUtils.SortArray('label'));
                        $scope.authModel.defaultValue = iamUtils.getCountryValue(codeList, defaultCode);
                        $scope.authModel.countryCodeList = codeList;
                        $scope.countryCodeModel.defaultCodeValue = iamUtils.getCountryValue(codeList, defaultCode);
                        $scope.countryCodeModel.countryCodeList = codeList;
                        for(var item in codeList){
                            $scope.countryCodeModel.countryCodeArray.push(codeList[item].label);
                        }
                    }
                }, function(){

                })
            }

            // 倒计时
            function retrieveCountdown() {
                var second = 60;
                $scope.authModel.retrieveTxt = iamUtils.i18nFormat(i18n('loginVerification.retrieveTxt'), second);
                var timerHandler;
                timerHandler = $interval(function(){
                    second--;
                    if(second < 0 ){
                        $interval.cancel(timerHandler);
                        $scope.authModel.sendCodeSuccess = false;
                    }else{
                        $scope.authModel.retrieveTxt = iamUtils.i18nFormat(i18n('loginVerification.retrieveTxt'), second);
                        $scope.authModel.sendCodeSuccess = true;
                    }
                },1000)
            }
            /* END */

            function getResetMFAHelpUrl() {
                var _url = "";
                if (ipIsInternational) {
                    // 国际IP 
                    if (window.language) {
                        _url = "/intl/" + window.language + "/iam_faq/iam_01_0004.html";
                    } else {
                        _url = "/intl/en-us/iam_faq/iam_01_0004.html";
                    }
                } else {
                    // 国内IP
                    if (window.language && window.language === "zh-cn") {
                        _url = "/iam_faq/iam_01_0004.html";
                    } else {
                        _url = "/en-us/iam_faq/iam_01_0004.html";
                    }
                }
                _url = "https://support.huaweicloud.com" + _url;
                
                return $sce.trustAsHtml(htmlTransformer.htmlDecode(iamUtils.i18nFormat(i18n('loginVerification.resetMFAHelpUrl'), _url)));
            }
            
            // 是否支持vmfa七天无需再次验证
            function isRememberMFASupported() {
                const mfaCookieArr = document.cookie.match(/rememberMFA_/g);
                return !mfaCookieArr || mfaCookieArr.length < 5;
            }

            verifyCtr.call(this, $scope, $sce, i18n, iamUtils, iamEnv, $filter, $interval);
        };
        
        $.extend(loginVerificationCtrl.prototype, verifyCtr.prototype);
        loginVerificationCtrl = ['$scope', '$sce', '$filter', '$interval', loginVerificationCtrl];
        var loginVerificationModule = angular.module('authui.config');
        loginVerificationModule.controller('authui.loginVerification.ctrl', loginVerificationCtrl);

        return loginVerificationCtrl;
    });



// WEBPACK FOOTER //
// ./public/hws/js/loginverification/controllers/loginVerificationController.js